import { Component } from '@angular/core';

/**
 * Skeleton component for product detail card
 * @export
 * @class AtmSkeletonProductDetailCardComponent
 */
@Component({
  selector: 'atm-skeleton-product-detail-card',
  templateUrl: './atm-skeleton-product-detail-card.component.html',
  styleUrls: ['./atm-skeleton-product-detail-card.component.scss']
})
export class AtmSkeletonProductDetailCardComponent {

}
